module.exports = __webpack_public_path__ + "img/BkgReporte.25eab936.jpg";